import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const opportunityTypesAdapter = getAdapter({ idFieldName: 'value' });

const opportunityTypesSlice = createSlice({
  name: 'opportunityTypes',
  initialState: opportunityTypesAdapter.getInitialState(),
  reducers: {
    setOpportunityTypes: (state, { payload: { opportunityTypes } }) => {
      opportunityTypesAdapter.setAll(state, opportunityTypes);
    },
  },
});

const selectors = opportunityTypesAdapter.getSelectors(({ opportunityTypes }) => opportunityTypes);

export const getOpportunityTypes = (state) => selectors.selectAll(state);

export const {
  setOpportunityTypes,
} = opportunityTypesSlice.actions;

export default opportunityTypesSlice.reducer;
